// Границы совпадают с deliveryTimeFormatter (common/helpers/formatter.helper.ts), но optionValue —
// это представительское значение конкретного пункта deliveryInDaysOptions для бакета, а не верхняя
// граница диапазона (например, бакет «72ч» — это дни 2–4, но представительское значение равно 3).
const deliveryDaysBuckets = [
  { maxDays: 1, optionValue: 1 },
  { maxDays: 4, optionValue: 4 },
  { maxDays: 7, optionValue: 7 },
  { maxDays: 21, optionValue: 21 },
  { maxDays: 30, optionValue: 30 },
  { maxDays: 90, optionValue: 60 },
  { maxDays: 120, optionValue: 120 },
];

// Приводит произвольное количество дней доставки с бека к ближайшему пресету из deliveryInDaysOptions,
// чтобы селектор срока доставки показывал корректный лейбл, даже если сырое значение не совпадает
// ни с одним пунктом списка.
export const getDeliveryOptionValue = (deliveryInDays: number | null): number | null => {
  if (deliveryInDays === null) {
    return null;
  }

  const bucket = deliveryDaysBuckets.find(({ maxDays }) => deliveryInDays <= maxDays);

  return bucket ? bucket.optionValue : deliveryInDays;
};
